import React from "react";
import { LogbookPage } from "./LogbookPage";

export const MESFLogbookReport = () => {
	return <LogbookPage />;
};
